import { useEffect, useRef } from 'react';

function usePrevious(value, defaultValue = null) {
  const ref = useRef(defaultValue);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}
export default usePrevious;
